import { lazy } from "react";
import paths from "../paths";
import { withPageWrapper } from "components/PageWrapper";

const Search = lazy(() => import("pages/search/index"));
const Product = lazy(() => import("pages/Product"));
const Products = lazy(() => import("pages/Products").then(module => ({ default: module.Products })));
const WinningProducts = lazy(() =>
  import("pages/WinningProducts").then(module => ({ default: module.WinningProducts }))
);
const Import = lazy(() => import("pages/Import").then(module => ({ default: module.Import })));
const Reviews = lazy(() => import("pages/Reviews").then(module => ({ default: module.Reviews })));
const PromoReviewsProPage = lazy(() =>
  import("components/PromoReviewsPro/PromotionPage").then(module => ({ default: module.default }))
);
//const Checkout = lazy(() => import("pages/Checkout").then(module => ({ default: module.Checkout })));
//const Payment = lazy(() => import("pages/Payment").then(module => ({ default: module.Payment })));
const Purchase = lazy(() => import("pages/Purchase").then(module => ({ default: module.Purchase })));

export const productRoutes = [
  { path: paths.product.index, Component: withPageWrapper(Search), app: true },
  { path: `${paths.product.index}/:id`, Component: withPageWrapper(Product), app: true },
  { path: paths.product.products, Component: withPageWrapper(Products), app: true, shop: true },
  {
    path: paths.product.import,
    Component: withPageWrapper(Import),
    app: true,
    shop: true
  },
  {
    path: paths.product.reviews,
    Component: withPageWrapper(Reviews),
    app: true,
    shop: true
  },
  {
    path: paths.app.promoReviews,
    Component: withPageWrapper(PromoReviewsProPage),
    app: true,
    shop: true
  },
  {
    path: paths.product.winningProducts,
    Component: withPageWrapper(WinningProducts),
    app: true,
    blockedForAmazonUsers: true
  },
  { path: paths.product.checkout, Component: withPageWrapper(Purchase), app: true },
  { path: paths.product.payment, Component: withPageWrapper(Purchase), app: true }
];
